import { render, staticRenderFns } from "./EditionItem.vue?vue&type=template&id=c0c4bf5e&scoped=true&"
import script from "./EditionItem.vue?vue&type=script&lang=js&"
export * from "./EditionItem.vue?vue&type=script&lang=js&"
import style0 from "./EditionItem.vue?vue&type=style&index=0&id=c0c4bf5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c4bf5e",
  null
  
)

export default component.exports